<template>

  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-brand center>Overseas Agent SOA</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button @click="filterClear">Clear</b-button>
              <!-- <b-button
                size="sm"
                class="ml-1"
                @click="getReportsReverse('Overseas_Agent_SOA_EXCEL')"
                variant="outline-info"
                >Export</b-button
              > -->
              <b-button size="sm" class="ml-1" @click="showExcelFunc(excelUploadFlag)" variant="outline-info">Import
                SOA</b-button>
              <b-button :disabled="ExcelBtnName != 'Export' ? true : false" class="ml-1 mr-1"
                @click="getReportsReverse('Overseas_Agent_SOA_EXCEL', 'Export')" size="sm" variant="outline-info">{{
                ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export'" small label="Small Spinner"></b-spinner></b-button>
              <Filter-Agency-Modal />
              <FilterCBModal />
              <ClientCard />
               <ShipmentTrackCard />
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card>
          <b-row class="mt-2">
            <b-col class="col-md-3">
              <label for="blType">To</label>
              <model-list-select :list="$store.getters['common/getAllAgentColoaderList']" option-value="agentName"
                option-text="agentName" v-model="Filter.ToFilter" placeholder="Select To"
                @input="SearchFilter"></model-list-select>
            </b-col>

            <b-col class="col-md-3">
              <label>Invoice Date :</label>
              <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
                :startDate="startDate" :endDate="endDate" :locale-data="locale"
                @update="SearchFilter"></date-range-picker>
            </b-col>
            <b-col class="col-md-3">
              <label>Payment Status</label>
              <model-list-select :list="filterstatusList" v-model="Filter.statusFilter" option-value="payVal"
                option-text="payText" placeholder="Select Status" @input="SearchFilter"></model-list-select>
            </b-col>
            <b-col class="col-md-3">
              <label>Type</label>
              <model-list-select :list="NoteTypeList" v-model="Filter.NoteTypeFilter" option-value="payVal"
                option-text="payText" placeholder="Select Status" @input="SearchFilter"></model-list-select>
            </b-col>
            <b-col class="col-md-3">
              <label for="blType">Common Filter</label>
              <b-form-input :formatter="capitalizeAll" v-model="Filter.CommonFilter" @input="SearchFilter"
                placeholder="Type To Search (Assignment No. / Client / Container No. / Shipping Line / BL NO / CR/DR NO / HBL )" />
            </b-col>
            <b-col class="col-md-3">
              <label>Branch</label>
              <model-list-select class="ml-1" :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                v-model="Filter.branchfilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                @input="SearchFilter" :isDisabled="
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                    ? true
                    : false
                "></model-list-select>
            </b-col>
            <b-col class="col-md-3 mt-4" v-if="excelUploadFlag">
              <label>Upload File</label>
              <input type="file" @change="onFileChange" accept=".xlsx, .xls,.csv" />
              <!-- <md-input-container>
                <label>Upload File</label>
                <md-file
                  name="excelUpload"
                  id="excelUpload"
                  v-model="excelUpload"
                  @selected="onFileChange()"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                ></md-file>
              </md-input-container> -->
            </b-col>
            <!-- <b-button
                size="sm"
                class="ml-1"
                @click="getReportsReverse('Overseas_Agent_SOA_EXCEL')"
                variant="outline-info">Export</b-button>
                <b-button
                size="sm"
                class="ml-1"
                @click="ExportSOAExcel()"
            variant="outline-info">Export SOA</b-button></b-col>-->
          </b-row>
          <b-row class="align-content-end mt-3">
            <b-col cols="8">
              <input type="checkbox" @click="SelectAll(CDCRARR)" v-model="isCheckAll" />
              <label>Select / Deselect All Count({{ this.note_ids.length }})</label>
              <b-button v-if="note_ids.length > 0" size="sm" @click="ProceedMultiPayment"
                variant="outline-primary">Multi Payment</b-button>
            </b-col>
            <b-col cols="2">
              <h5 class="text-muted pull-right">
                <small v-if="isLoading == false">{{ totalRows }} Entries</small>
              </h5>
            </b-col>
            <b-col cols="2" style="padding: 0px 1rem 0 5rem">
              <model-list-select :list="PaginationList" v-model="PaginationCount" option-value="pagv" option-text="pagt"
                placeholder="Select" @input="pagechangeData()"></model-list-select>
            </b-col>
          </b-row>
        </b-card>

        <!-- Main table element -->
        <div class="table-responsive tableMain">
          <b-table show-empty stacked="md" :items="CDCRARR" responsive :fields="Columns" primary-key="note_id"
            :per-page="pagination.perPage" :current-page="pagination.currentPage" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" :sort-direction="sortDirection" class="position-relative">
            <template slot="note_id" slot-scope="row0">
              <input v-if="row0.item.payStatus != '1' && row0.item.payStatus != '2'" type="checkbox"
                v-bind:value="row0.item.note_id" v-model="note_ids" @change="updateSelectAll($event, row0.item)" />
              <span>
                {{ row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage }}
              </span>
            </template>
            <template slot="noteSeries" slot-scope="row1">
              <span variant="info">
                CR/DR No.:
                <b>{{ row1.item.noteSeries }}</b>
              </span>
              <br />
              <span variant="info">
                Created:
                <b>{{ row1.item.noteDate }}</b>
              </span>
              <br />
            </template>
            <template slot="note_type" slot-scope="row2">
              <span variant="info">
                <b>
                  {{ row2.item.note_type == "CR" ? "Credit" : "Debit" }}
                </b>
              </span>
              <br />
            </template>
            <template slot="AgentColoader" slot-scope="row3">
              <span variant="info">
                <b>{{ row3.item.AgentColoader }}</b>
              </span>
              <br />
            </template>
            <template slot="mainSalesSeries" slot-scope="row4">
              <span>
                Ass No:
                <b>{{ row4.item.mainSalesSeries }}</b>
              </span>
              <br />
              <span>
                Ass Date:
                <b>{{ row4.item.assDate }}</b>
              </span>
              <br />
              <span>
                Ass Branch:
                <b>{{ row4.item.raisedFrom }}</b>
              </span>
              <br />
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :assign_date="row4.item.assDate"
                :assign_job_type="''" :assign_raised_from="'Raised From: ' + row4.item.raisedFrom"
                :assign_raised_by="'Raised By: '" :fk_all_module_id="row4.item.allModuleId"
                :jb_series="row4.item.mainSalesSeries" :fk_client_id="''" :fk_pod_id="''" />
                <JobWisePaymentsDetails
                  v-if="row4.item.allModuleId"
                  :allModuleId="Number(row4.item.allModuleId)"
                  :JobNo="row4.item.mainSalesSeries"
                  />
                  <RejectInvTallyBillSummary
                    v-if="row4.item.allModuleId"
                    :PMC_title="'Invoice Rejection Log Summary Job No - ' + row4.item.mainSalesSeries"
                    :PMC_JOBID="row4.item.allModuleId.toString()"
                    :PMC_JOBNO="row4.item.mainSalesSeries"
                    :PMC_JOBDATE="''"
                    :PMC_JOBTYPE="''"
                    :PMC_Client="''"
                    :PMC_Sline="''"
                  />
              <ContainerSummary v-if="row4.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row4.item.mainSalesSeries"
                :PMC_JOBID="row4.item.allModuleId" :PMC_JOBNO="row4.item.mainSalesSeries" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_AgentType="''" :PMC_Client="''" :PMC_Sline="''" />
            </template>
            <template slot="noteAmount" slot-scope="row5" width="25%">
              <span variant="info">
                <b>
                  {{ row5.item.totalAmt + " " + row5.item.currencyName }}
                </b>
              </span>
              <br />
              <b v-if="row5.item.payMode == 1">
                <b-badge class="p-1 mt-1" variant="success">RTGS</b-badge>
              </b>
              <b v-else-if="row5.item.payMode == 2">
                <b-badge class="p-1 mt-1" size="sm" variant="info">Cheque</b-badge>
              </b>
              <b v-else-if="row5.item.payMode == 3">
                <b-badge class="p-1 mt-1" size="sm" variant="warning">Online</b-badge>
              </b>
            </template>

            <template slot="action" slot-scope="row4">
              <!-- {{row4.item}} -->
              <b-button v-if="row4.item.note_id" @click="openpaymentModal(row4.item)" size="sm"
                variant="outline-success">Pay</b-button>
              <b-button class="mt-1" v-if="row4.item.note_id"
                @click="PrintNote(row4.item.mainSalesSeries, row4.item.uploadCreditDebit)" size="sm"
                variant="warning">PDF</b-button>

              <b v-if="row4.item.payStatus == 1">
                <b-badge class="p-1 mt-1" variant="success">Paid</b-badge>
              </b>
              <b v-else>
                <b-badge class="p-1 mt-1" size="sm" variant="warning">Pending</b-badge>
              </b>
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination limit="8" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalRows" @change="onPageChange($event)"></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>

    <!-- Added By Priyanshu SIngh STart -->
    <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="payment-Modal" hide-footer :title="
        paymentModal.creditDebitNoteType == 'CR'
          ? 'CREDIT NOTE Payment Details'
          : 'DEBIT NOTE Payment Details'
      ">
      <b-row class="justify-content-center">
        <b-col cols="2">
          <label for="blType">
            Invoice No.
            <span class="error">*</span>
          </label>
          <b-button v-if="paymentModal.uploadCreditDebit && paymentModal.noteSeries"
            @click="PrintNote(paymentModal.assignmentNo, paymentModal.uploadCreditDebit)" size="sm" variant="warning">
            <b style="color: white" v-if="paymentModal.noteSeries">
              {{ paymentModal.noteSeries }}
            </b>
          </b-button>
        </b-col>
        <b-col cols="2">
          <label>
            Invoice Amount
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" :disabled="paymentModal.payAmount ? true : false" name="payAmount"
            id="payAmount" v-model="paymentModal.payAmount" type="number"></b-form-input>
          <span class="error" v-if="!paymentModal.payAmount ? true : false">
            {{ errorPayment.payAmount }}
          </span>
        </b-col>
        <b-col cols="2">
          <label>
            Currency
            <span class="error">*</span>
          </label>
          <model-list-select :isDisabled="
              paymentModal.payCurrencyId &&
              paymentModal.payStatus &&
              $sessionsStorage.get('designation') != 'Admin' &&
              $sessionsStorage.get('nameUser') != 'Bhavneesh'
                ? true
                : false
            " :list="$store.getters['common/getAllCurrencyList']" v-model="paymentModal.payCurrencyId"
            option-value="currency_id" option-text="currencyCode" placeholder="Select Currency"></model-list-select>
          <span class="error" v-if="!paymentModal.payCurrencyId ? true : false">{{
            errorPayment.payCurrencyId
            }}</span>
        </b-col>
        <b-col cols="2">
          <label>
            Payment Mode
            <span class="error">*</span>
          </label>
          <model-list-select :isDisabled="paymentModal.payMode && paymentModal.payStatus ? true : false" :list="payList"
            v-model="paymentModal.payMode" option-value="payVal" option-text="payText"
            placeholder="Select Payment Mode"></model-list-select>
          <span class="error" v-if="!paymentModal.payMode ? true : false">
            {{ errorPayment.payMode }}
          </span>
        </b-col>
        <b-col cols="2">
          <label>
            Payment Ref
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" :disabled="
              paymentModal.payRef &&
              paymentModal.payStatus &&
              $sessionsStorage.get('designation') != 'Admin' &&
              $sessionsStorage.get('nameUser') != 'Bhavneesh'
                ? true
                : false
            " name="payRef" id="payRef" v-model="paymentModal.payRef" type="text"></b-form-input>
          <span class="error" v-if="!paymentModal.payRef ? true : false">
            {{ errorPayment.payRef }}
          </span>
        </b-col>
        <b-col cols="2">
          <label>
            Payment Amount
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" :disabled="
              paymentModal.paidAmount &&
              paymentModal.payStatus &&
              $sessionsStorage.get('designation') != 'Admin' &&
              $sessionsStorage.get('nameUser') != 'Bhavneesh'
                ? true
                : false
            " name="payAmount" id="payAmount" v-model="paymentModal.paidAmount" type="number"></b-form-input>
          <span class="error" v-if="!paymentModal.paidAmount ? true : false">
            {{ errorPayment.paidAmount }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>Payment Status</label>
          <model-list-select :isDisabled="
              paymentModal.payStatus &&
              $sessionsStorage.get('designation') != 'Admin' &&
              $sessionsStorage.get('nameUser') != 'Bhavneesh'
                ? true
                : false
            " :list="statusList" v-model="paymentModal.payStatus" option-value="payVal" option-text="payText"
            placeholder="Select Status"></model-list-select>
          <span class="error" v-if="!paymentModal.payStatus ? true : false">
            {{ errorPayment.payStatus }}
          </span>
        </b-col>
        <b-col cols="2">
          <label>
            Payment Date
            <span class="error">*</span>
          </label>
          <br />
          <date-picker :disabled="paymentModal.payDate && paymentModal.payStatus ? true : false"
            :format="selectDateFormat" lang="en" name="payDate" id="payDate" v-model="paymentModal.payDate"
            :minute-step="1"></date-picker>
          <span class="error" v-if="!paymentModal.payDate ? true : false">
            {{ errorPayment.payDate }}
          </span>
        </b-col>
        <b-col cols="12">
          <label for="Remarks">Remarks</label>
          <b-form-textarea :formatter="capitalizeAll" v-model="paymentModal.remark" rows="3"></b-form-textarea>
        </b-col>

        <b-col cols="10" class="text-center">
          <b-button :disabled="
              paymentModal.crdr_id &&
              $sessionsStorage.get('designation') != 'Admin' &&
              $sessionsStorage.get('nameUser') != 'Bhavneesh'
                ? true
                : false
            " class="mt-3" variant="success" v-if="paymentModal.note_id" @click="submitPayment">Save</b-button>
          <b-button class="mt-3" variant="outline-danger" @click="hidepaymentModal">Close</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="Multi-Payment-Modal" ref="Multi-Payment-Modal" title="Multi Payment" centered no-close-on-esc
      no-close-on-backdrop hide-footer>
      <b-row>
        <b-col cols="12">
          <label>
            Payment Date
            <span class="error">*</span>
          </label>
          <date-picker lang="en" name="payDate" id="payDate" type="datetime" format="YYYY-MM-DD hh:mm a"
            :minute-step="1" v-model="MultiPayment.payDate"></date-picker>
          <span class="error" v-if="!MultiPayment.payDate">
            {{ errorMultiPayment.payDate }}
          </span>
        </b-col>
        <b-col cols="12">
          <label>
            Payment Ref
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" name="payRef" id="payRef" v-model="MultiPayment.payRef"
            type="text"></b-form-input>
          <span class="error" v-if="!MultiPayment.payRef ? true : false">
            {{ errorMultiPayment.payRef }}
          </span>
        </b-col>
        <b-col cols="12">
          <label>
            Payment Remark
            <span class="error">*</span>
          </label>
          <b-form-textarea :formatter="capitalizeAll" rows="5" id="name-input"
            v-model="MultiPayment.remark"></b-form-textarea>
          <span class="error" v-if="!MultiPayment.remark">
            {{ errorMultiPayment.remark }}
          </span>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="4"></b-col>
        <b-col cols="4">
          <b-button :disabled="MultiPayment.remark && MultiPayment.payDate ? false : true" class="sm" variant="success"
            @click="PayMultiPayment">Pay</b-button>
          <b-button @click="closeMultiPaymentModal" variant="danger" class="pull-right sm">Close</b-button>
        </b-col>
        <b-col cols="4"></b-col>
      </b-row>
    </b-modal>
    <!-- Added By Priyanshu SIngh End -->
  </div>
</template>

<script>
import CommonService from "../../services/CommonService.js";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC, PRIDELdashboardName } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import DateRangePicker from "vue2-daterange-picker";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import CustomLoader from "../common/customLoader.vue";
// import XLSX from "xlsx";
import axios from "axios";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getCurrentLastDate();
    let payload = {
      Currency: "Currency_DropDown",
    };
    this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload));
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    if (globalPermissionStatus("Overseas Agent Assignments")) {
      this.$store.dispatch("setCurrentRoute", "/overseas/OverseasAgentSOA");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getAllCreditDebitNoteList();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export",
      excelUpload: "",
      excelUploadFlag: false,
      isCheckAll: false,
      note_ids: [],
      selectednote_ids: "",
      PaginationList: [
        {
          pagv: "25",
          pagt: "25",
        },
        {
          pagv: "50",
          pagt: "50",
        },
        {
          pagv: "75",
          pagt: "75",
        },
        {
          pagv: "100",
          pagt: "100",
        },
        {
          pagv: "125",
          pagt: "125",
        },
        {
          pagv: "150",
          pagt: "150",
        },
        {
          pagv: "175",
          pagt: "175",
        },
        {
          pagv: "200",
          pagt: "200",
        },
        {
          pagv: "225",
          pagt: "225",
        },
        {
          pagv: "250",
          pagt: "250",
        },
        {
          pagv: "275",
          pagt: "275",
        },
        {
          pagv: "300",
          pagt: "300",
        },
        {
          pagv: "325",
          pagt: "325",
        },
        {
          pagv: "350",
          pagt: "350",
        },
        {
          pagv: "375",
          pagt: "375",
        },
        {
          pagv: "400",
          pagt: "400",
        },
      ],
      PaginationCount: "",
      validate: true,
      currList: [],
      Filter: {
        NoteTypeFilter: "all",
        ToFilter: "",
        statusFilter: "3",
        CommonFilter: "",
        branchfilter: "",
      },
      paymentModal: {
        crdr_id: "",
        ispaymentActive: "",
        noteSeries: "",
        assignmentNo: "",
        uploadCreditDebit: "",
        payAmount: "",
        payCurrencyId: "",
        payCurrency: "",
        payMode: "",
        payRef: "",
        creditDebitNoteType: "",
        payStatus: "",
        paidAmount: "",
        note_id: "",
        noteAmount: "",
        payDate: "",
        remark: "",
        allModuleId: "",
      },
      errorPayment: {
        payAmount: "",
        payCurrencyId: "",
        payMode: "",
        payRef: "",
        payAmount: "",
        payStatus: "",
        paidAmount: "",
        payDate: "",
      },
      arrayPayment: [
        {
          payAmount: "Please Enter Invoice AMt",
          payCurrencyId: "Select Currecny",
          payAmount: "Select Payment Mode",
          payRef: "Please Enter Payment Reference No.",
          payStatus: "Select Payment Status",
          paidAmount: "Please Enter Paid AMt",
          payDate: "Select Payment Date",
          payMode: "Select Payment Mode",
        },
      ],
      MultiPayment: {
        remark: "",
        payDate: "",
        payRef: "",
        all_note_ids: [],
      },
      errorMultiPayment: {
        remark: "",
        payDate: "",
        payRef: "",
      },
      arrayMultiPayment: [
        {
          remark: "Please Enter Remark",
          payDate: "Select Payment Date",
          payRef: "Please Enter Payment Ref. No.",
        },
      ],
      selectDateFormat,
      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },

      totalRows: 0,

      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      CDCRARR: [],
      Columns: [
        {
          key: "note_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "noteSeries",
          label: "CR/DR No.",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "note_type",
          label: "Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "AgentColoader",
          label: "To",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "mainSalesSeries",
          label: "Assignment No",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "overseas_agent",
          label: "Overseas Agent",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "noteAmount",
          sortable: true,
          label: "Tot. AMT             ",
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      totAmt: 0,
      payList: [
        // {
        //   payVal: "1",
        //   payText: "RTGS",
        // },
        // {
        //   payVal: "2",
        //   payText: "Cheque",
        // },

        {
          payVal: "3",
          payText: "Online",
        },
      ],
      statusList: [
        {
          payVal: "1",
          payText: "COMPLETED",
        },
        {
          payVal: "2",
          payText: "PARTIAL",
        },
      ],
      filterstatusList: [
        {
          payVal: "1",
          payText: "Paid",
        },
        {
          payVal: "2",
          payText: "Pending",
        },
        {
          payVal: "3",
          payText: "All",
        },
      ],
      NoteTypeList: [
        {
          payVal: "CR",
          payText: "Credit Note",
        },
        {
          payVal: "DR",
          payText: "Debit Note",
        },

        {
          payVal: "all",
          payText: "All",
        },
      ],
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  components: {
    Loading,
    ModelListSelect,
    DocForm,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    AddMessage,
    AssignmentSummary,
    DateRangePicker,
    DatePicker,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
    CustomLoader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  watch: {
    milestoneFiltersD: {
      handler(newVal, oldVal) {},
      deep: true,
    },
  },

  methods: {
    showExcelFunc(excelUploadFlag) {
      if (excelUploadFlag == true) {
        this.excelUploadFlag = false;
      }else{
        this.excelUploadFlag = true;
      }
    },
    // ExportSOAExcel() {
    //   if (this.CDCRARR.length > 0) {
    //     var dataOne = XLSX.utils.json_to_sheet(this.CDCRARR);
    //     var wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, dataOne, "Overses_Agent_SOA");
    //     let ExcelDate = new Date().toDateString();
    //     if (this.dateSearch.fromDate) {
    //       ExcelDate = new Date(this.dateSearch.fromDate).toDateString();
    //     } else {
    //       ExcelDate = new Date().toDateString();
    //     }
    //     XLSX.writeFile(
    //       wb,
    //       `${PRIDELdashboardName.toUpperCase()}_Overses_Agent_SOA_DETAILS_Report_${ExcelDate}.xlsx`
    //     );
    //   }
    // },
    getReportsReverse(id, btnName) {
      let excelIdGivin = "";
      if (id == "Overseas_Agent_SOA_EXCEL") {
        excelIdGivin = "Overseas_Agent_SOA_EXCEL";
      }
      let payload = {
        excelId: excelIdGivin,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        Filter: this.Filter,
      };
      this.ExcelBtnName= "Downloading Please Wait...",
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        this.ExcelBtnName= btnName,
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    PrintNote(assignmentNo, uploadCreditDebit) {
      let key =
        "ASSIGNMENT_UPLOADS/" +
        assignmentNo.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },
    async openpaymentModal(item) {
      console.log("Happy SIn gh=>", item);
      this.TotAMT = 0;
      // let CurrencyArr = await this.getCurrencyList();
      this.paymentModal.crdr_id = item.crdr_id;
      this.paymentModal.assignmentNo = item.mainSalesSeries;
      this.paymentModal.noteSeries = item.noteSeries;
      this.paymentModal.allModuleId = item.allModuleId;
      this.paymentModal.note_id = item.note_id;
      this.paymentModal.uploadCreditDebit = item.uploadCreditDebit;
      this.paymentModal.payAmount = item.totalAmt ? item.totalAmt : item.payAmount;
      this.paymentModal.payCurrencyId = item.payCurrencyId
        ? item.payCurrencyId
        : item.fk_currency_id;
      this.paymentModal.payCurrency = item.payCurrency;
      this.paymentModal.payMode = item.payMode;
      this.paymentModal.payRef = item.payRef;
      this.paymentModal.creditDebitNoteType = item.note_type;
      this.paymentModal.payStatus = item.payStatus;
      this.paymentModal.paidAmount = item.paidAmount;
      this.paymentModal.noteAmount = item.totalAmt;
      this.paymentModal.payDate = item.payDate;
      this.paymentModal.remark = item.remark;
      console.log("Happy SIn gh=>", this.paymentModal);

      this.$refs["payment-Modal"].show();
    },
    hidepaymentModal() {
      this.paymentModal = {
        crdr_id: "",
        ispaymentActive: "",
        assignmentNo: "",
        noteSeries: "",
        payAmount: "",
        payCurrencyId: "",
        payCurrency: "",
        payMode: "",
        payRef: "",
        creditDebitNoteType: "",
        payStatus: "",
        paidAmount: "",
        note_id: "",
        noteAmount: "",
        payDate: "",
        remark: "",
        allModuleId: "",
      };
      this.$refs["payment-Modal"].hide();
      this.isLoading = false;
    },
    validatePaymentDetails() {
      let validate_new = true;
      Object.keys(this.errorPayment).map((x, index) => {
        if (
          this.paymentModal[x] == "" ||
          this.paymentModal[x] == undefined ||
          this.paymentModal[x] == "undefined"
        ) {
          this.errorPayment[x] = this.arrayPayment[0][x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    submitPayment() {
      this.validatePaymentDetails();
      if (this.validate == false) return false;
      this.isLoading = true;
      let payload = {
        filter: "Overseas_Agent_SOA_Payment",
        paymentModal: this.paymentModal,
      };
      payload = JSON.stringify(payload);
      CommonService.proceedCRDRPaymentDetails(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.crdr_id != "" && data.crdr_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.hidepaymentModal();
            this.$refs["addPop"].open();
            this.getAllCreditDebitNoteList();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Overseas_Agent_SOA Error: ", error);
        });
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      let firstYear = firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1;
      let newdate = firstYear + "-04-01";
      firstDay = new Date(newdate);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },
    // async
    getAllCreditDebitNoteList() {
      this.isLoading = true;
      let payload = {
        filter: "Overseas_Agent_SOA",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        Filter: this.Filter,
      };
      // JSON.stringify();
      // await
      CommonService.getAllCreditDebitNoteList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.CDCRARR = data.overseasAgentSOA_data;
            this.totalRows = data.overseasAgentSOA_data.length;
            console.log(" Overseas_Agent_SOA response=>", data);
          } else {
            this.CDCRARR = [];
          }
          this.isLoading = false;
          this.PaginationCount = this.pagination.perPage;
        })
        .catch((error) => {
          console.log("Catch on Overseas_Agent_SOA Error: ", error);
        });
    },
    validateMultiPaymentDetails() {
      let validate_new = true;
      Object.keys(this.errorMultiPayment).map((x, index) => {
        if (
          this.MultiPayment[x] == "" ||
          this.MultiPayment[x] == undefined ||
          this.MultiPayment[x] == "undefined"
        ) {
          this.errorMultiPayment[x] = this.arrayMultiPayment[0][x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    ProceedMultiPayment() {
      this.$refs["Multi-Payment-Modal"].show();
    },
    PayMultiPayment() {
      this.validateMultiPaymentDetails();
      if (this.validate == false) return false;
      this.isLoading = true;
      this.MultiPayment.all_note_ids = this.note_ids;
      let payload = {
        filter: "Overseas_Agent_SOA_MultiPayment",
        MultiPayment: this.MultiPayment,
      };
      payload = JSON.stringify(payload);
      CommonService.proceedCRDRPaymentDetails(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.crdr_id != "" && data.crdr_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.closeMultiPaymentModal();
            this.$refs["addPop"].open();
            this.getAllCreditDebitNoteList();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Overseas_Agent_SOA Error: ", error);
        });
    },
    closeMultiPaymentModal() {
      this.$refs["Multi-Payment-Modal"].hide();
    },

    SearchFilter(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllCreditDebitNoteList();
      }, 1000);
    },
    pagechangeData() {
      this.pagination.perPage = this.PaginationCount;
      this.reload = false;
      this.getAllCreditDebitNoteList();
    },

    wordWrap,
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllCreditDebitNoteList();
    },
    filterClear() {
      (this.Filter = {
        NoteTypeFilter: "all",
        ToFilter: "",
        statusFilter: "3",
        CommonFilter: "",
        branchfilter: "",
      }),
        (this.dateSearch.fromDate = "");
      this.dateSearch.toDate = "";
      this.getCurrentLastDate();
      this.getAllCreditDebitNoteList();
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllCreditDebitNoteList();
    },
    SelectAll: function () {
      this.isCheckAll = !this.isCheckAll;
      this.note_ids = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.CDCRARR) {
          if (this.CDCRARR[key].payStatus != 1 && this.CDCRARR[key].payStatus != 2) {
            let single_data = "";
            this.note_ids.push(this.CDCRARR[key].note_id);
          }
        }
      }
    },
    updateSelectAll: function (e, item) {
      if (this.note_ids.length == this.CDCRARR.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      const istrue = this.note_ids.includes(item.note_id);
      if (istrue == true) {
        const index = this.note_ids.indexOf(item.note_id);
        this.note_ids.splice(index, 1);
      }
    },

    // Main Table
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.pagination.currentPage = 1;
    },
    onFileChange(event) {
      //  var files = event.target.files ? event.target.files[0] : null;
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();
      console.log("files=>",files)

      for (let i = 0; i < files.length; i++) {
        formData.append(`SOA_IMP[]`, files[i]);
      }
      // alert(files.length)
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadSOAMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only CSV Format Support") {
            this.alert.content = "Only .csv format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.getAllCreditDebitNoteList();
        })
        .catch((err) => {
          throw err;
        });
    },
    // Added By Priyanshu SIngh End
  },
};
</script>
<style scoped>
.colwidth {
  min-width: 200px !important;
}
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// overseasAgentSoa.vue?4f95c3e2